'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
/**
 * Retrieves the document where the React Component has been
 * mounted to.
 *
 * @param   {React.Component} Component A React.Component.
 * @returns {document} The closest document.
 */


function getDocumentFromReactComponent(Component) {
  if (!Component || (typeof Component === 'undefined' ? 'undefined' : _typeof(Component)) !== 'object') return document; // React 16.x

  if (Component._reactInternalFiber) {
    return Component._reactInternalFiber.return && Component._reactInternalFiber.return.stateNode && Component._reactInternalFiber.return.stateNode.ownerDocument; // React 15.x
  } else if (Component._reactInternalInstance) {
    return Component._reactInternalInstance._context && Component._reactInternalInstance._context.document;
  } else {
    return document;
  }
}

exports.default = getDocumentFromReactComponent;